// queries/getCertifications.ts
import { Certification } from '../types';

const staticCertifications: Certification[] = [
  {
    title: "Cybersecurity Specialisation",
    issuer: "Google and LinkedIn",
    issuedDate: "2023",
    link: "https://www.coursera.org/account/accomplishments/specialization/certificate/NRDSV4XNZCAC",
    iconName: "google"
  },
  {
    title: "Career Essentials in Software Development",
    issuer: "Microsoft",
    issuedDate: "2023",
    link: "https://www.linkedin.com/learning/certificates/25e954ba62c8a9efdbd4079e2aaa1f6ab4d61f4c2c9f30d929919b464ad09b51?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BVVFb9z4CQcu4pRbbTreg1g%3D%3D",
    iconName: "microsoft"
  },
  {
    title: "Software Engineer Hackerrank",
    issuer: "HackerRank",
    issuedDate: "2024",
    link: "https://www.hackerrank.com/certificates/39498cc82ba1",
    iconName: "hackerrank"
  },
  {
    title: "Frontend Developer Hackerrank",
    issuer: "HackerRank",
    issuedDate: "2024",
    link: "https://www.hackerrank.com/certificates/7d6b20089429",
    iconName: "hackerrank"
  },
  {
    title: "Automate Cybersecurity Tasks with Python",
    issuer: "Coursera",
    issuedDate: "2024",
    link: "https://www.hackerrank.com/certificates/7d6b20089429",
    iconName: "coursera"
  },
  {
    title: "Postman API Fundamentals Student Expert",
    issuer: "Postman",
    issuedDate: "2024",
    link: "https://www.hackerrank.com/certificates/7d6b20089429",
    iconName: "postman"
  },
];

export async function getCertifications(): Promise<Certification[]> {
  // Simulate async behavior
  return new Promise((resolve) => {
    setTimeout(() => resolve(staticCertifications), 100);
  });
}
